<template>
  <div>
    <div class="d-flex justify-content-center text-primary" v-if="loadingTable">
      <b-spinner type="grow"></b-spinner>
    </div>
    <table class="table" v-else>
      <thead>
        <tr>
          <th>{{ $t('menu.settings.alertsNewsletters.savedRules') }}</th>
          <th>{{ $t('menu.settings.alertsNewsletters.actions') }}</th>
        </tr>
        <tr v-for="(item, i) in listRules" :key="i">
          <td>{{ item.name }}</td>

          <td style="width: 120px;">
            <button
              v-b-modal="`modal-edit-rule-${i}`"
              class="btn btn-outline-primary"
            >
              <font-awesome-icon :icon="['fas', 'pen']" />
            </button>
            <button
              @click="deleteOneRule(item._id)"
              class="btn btn-outline-danger"
            >
              <font-awesome-icon :icon="['fas', 'trash-alt']" />
            </button>
            <modal-edit-rule :ruleId="i" :rule="item" />
          </td>
        </tr>
      </thead>
    </table>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import swal from 'sweetalert';
import ModalEditRule from '@/components/molecules/modal-edit-rule';

export default {
  name: 'TableRules',
  components: {
    ModalEditRule,
  },

  data: () => ({
    userAuth: null,
  }),

  computed: {
    ...mapState('alertRules', ['listRules', 'loadingTable']),
  },

  methods: {
    ...mapActions('alertRules', ['setList', 'deleteRule', 'updateRule']),
    deleteOneRule(id) {
      swal({
        title: this.$t(
          'menu.settings.alertsNewsletters.messages.deleteRuleQuestion.title',
        ),
        text: this.$t(
          'menu.settings.alertsNewsletters.messages.deleteRuleQuestion.description',
        ),
        icon: 'warning',
        buttons: [
          this.$t(
            'menu.settings.alertsNewsletters.messages.deleteRuleQuestion.cancel',
          ),
          this.$t(
            'menu.settings.alertsNewsletters.messages.deleteRuleQuestion.delete',
          ),
        ],
        dangerMode: true,
      }).then((deleted) => {
        if (deleted) {
          swal(
            this.$t(
              'menu.settings.alertsNewsletters.messages.deleteRuleQuestion.deletedOk',
            ),
            { icon: 'success' },
          );
          this.deleteRule({
            id,
            token: this.userAuth.token,
          }).then(() => {
            this.setList({
              token: this.userAuth.token,
              companyId: this.userAuth.companyId,
            });
          });
        }
      });
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  async mounted() {
    this.setList({
      token: this.userAuth.token,
      companyId: this.userAuth.companyId,
    }).then(() => {
      this.$store.state.alertRules.loadingTable = false;
    });
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/organisms/settings/settings-alert-rules/table-rules/index.vue